/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./app-heart-beat.component";
import * as i2 from "../common.service";
import * as i3 from "./app-heart-beat.service";
var styles_AppHeartBeatComponent = [];
var RenderType_AppHeartBeatComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_AppHeartBeatComponent, data: {} });
export { RenderType_AppHeartBeatComponent as RenderType_AppHeartBeatComponent };
export function View_AppHeartBeatComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_AppHeartBeatComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-heart-beat", [], null, null, null, View_AppHeartBeatComponent_0, RenderType_AppHeartBeatComponent)), i0.ɵdid(1, 4440064, null, 0, i1.AppHeartBeatComponent, [i2.CommonService, i3.AppHeartBeatService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AppHeartBeatComponentNgFactory = i0.ɵccf("app-heart-beat", i1.AppHeartBeatComponent, View_AppHeartBeatComponent_Host_0, { browserPlatformLocation: "browserPlatformLocation" }, {}, []);
export { AppHeartBeatComponentNgFactory as AppHeartBeatComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/app-heart-beat/app-heart-beat.component.ngfactory.js.pre-build-optimizer.js